<div class="discount-group-row" (click)="getDiscount.emit(discountGroup?.id)">
  <div class="discount-group-row__content">
    <lp-discount-tag
      [productDiscountType]="discountGroup?.discountType"
      [productDiscount]="discountGroup?.discount"
      [variant]="'prefix'"
    ></lp-discount-tag>

    <div class="title">
      {{ discountGroup?.groupName }}
    </div>
  </div>

  <lp-export-codes-button
    *ngIf="allowedProductCodesExport"
    [size]="isMobile ? 'm' : 'l'"
    [productGroupId]="discountGroup?.id"
    [unionId]="productUnionId"
  ></lp-export-codes-button>
</div>
